import { Chatbot } from './chatbot.model';

export class ChatbotVo {
    chatbot: Chatbot;

    constructor(chatBot: Chatbot){
        this.chatbot = chatBot;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/model/chatbot.model.vo.ts